import React from "react";
import { teamData } from "../data/teamData";
import "./About.css";
import useDocumentTitle from "../hooks/useDocumentTitle";

const About = () => {
  useDocumentTitle("About Us");

  return (
    <main className="about-page">
      <div className="container">
        <section className="about-section">
          <div className="about-content">
            <div className="about-text">
              <h1>Our Story</h1>

              <p>
                Sampanna Sanchar Pvt. Ltd. was founded with a vision to create
                meaningful visual content that drives social change. Since our
                establishment, we have been dedicated to producing high-quality
                video content that not only informs but also inspires action.
              </p>

              <p>
                With a special focus on WASH (Water, Sanitation, and Hygiene)
                initiatives, we've collaborated with various NGOs, government
                agencies, and international organizations to create impactful
                awareness campaigns.
              </p>
            </div>

            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Projects Completed</div>
              </div>

              <div className="stat-item">
                <div className="stat-number">25+</div>
                <div className="stat-label">Clients</div>
              </div>

              <div className="stat-item">
                <div className="stat-number">4+</div>
                <div className="stat-label">Awards Won</div>
              </div>

              <div className="stat-item">
                <div className="stat-number">500k+</div>
                <div className="stat-label">Views Generated</div>
              </div>
            </div>
          </div>
        </section>

        <section className="mission-section">
          <div className="mission-vision">
            <div className="mission">
              <h2>Our Mission</h2>
              <p>
                To create compelling visual stories that promote positive social
                change, with a focus on water, sanitation, and hygiene
                awareness.
              </p>
            </div>

            <div className="vision">
              <h2>Our Vision</h2>
              <p>
                To produce impactful, socially conscious content that transforms
                communities.
              </p>
            </div>
          </div>
        </section>

        <section className="team-section">
          <h2>Meet Our Team</h2>

          <p className="team-intro">
            Passionate professionals dedicated to creating impactful content.
          </p>

          <div className="team-grid">
            {teamData.map((member) => (
              <article key={member.id} className="team-card">
                <div className="team-image">
                  <img src={member.image} alt={member.name} loading="lazy" />
                </div>

                <div className="team-info">
                  <h3>{member.name}</h3>

                  <p className="position">{member.position}</p>

                  <p className="bio">{member.bio}</p>

                  <div className="team-social">
                    {member.social?.linkedin && (
                      <a
                        href={member.social.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} on LinkedIn`}
                      >
                        LinkedIn
                      </a>
                    )}

                    {member.social?.twitter && (
                      <a
                        href={member.social.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${member.name} on Twitter`}
                      >
                        Twitter
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
};

export default About;
